import {IDebtorDetails} from '../models/debtors';

export {formatDebtorBalance} from './quote-currency.utils';

/**
 * Ensures a debtor record has debtorId and account populated for quote flows.
 */
export const normalizeQuoteDebtor = (debtor: IDebtorDetails): IDebtorDetails => {
  const debtorId = (debtor.debtorId ?? debtor.account ?? '').trim();
  return {
    ...debtor,
    debtorId,
    account: debtor.account?.trim() || debtorId,
  };
};

/**
 * Returns true when the debtor has a usable identifier for quote compose.
 */
export const hasQuoteDebtorId = (debtor: IDebtorDetails | null | undefined): boolean => {
  const debtorId = (debtor?.debtorId ?? debtor?.account ?? '').trim();
  return debtorId.length > 0;
};
